interface UnwatchSize {
    (): void;
}

export function watchSize(element: HTMLElement, callback: (width: number, height: number) => void): UnwatchSize {
    let monitorElementRaf: number;
    let width = element.offsetWidth;
    let height = element.offsetHeight;

    const monitorElement = () => {
        let rafCallback = () => {
            if (width !== element.offsetWidth || height !== element.offsetHeight) {
                width = element.offsetWidth;
                height = element.offsetHeight;
                callback(width, height);
            }
            monitorElement();
        };
        monitorElementRaf = requestAnimationFrame(rafCallback);
    };

    const stopMonitorElement = () => {
        cancelAnimationFrame(monitorElementRaf);
    };

    monitorElement();
    return stopMonitorElement;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/watchSize.ts
 **/